import html from "html-literal";
export default () => html`
  <p>fore oh fore, you did wrong, womp womp :(</p>
`;
